const doc = [({"label":"block semibold m-b-8"})];
module.exports = doc.length <= 1 ? doc[0] : doc;